import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  actionText?: string;
  actionTo?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  icon,
  actionText,
  actionTo,
}: SectionHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-base text-accent-700 md:h-8 md:w-8">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          {actionText}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}